<template>
    
    <el-container>
      <el-header style="background-color:#20214d; height:60px;display:flex; align-items:center; justify-content:space-between; ">
         <div style="font-size:22px;color:#fff; height:60px;display:flex; margin-left:20px; align-items:center;">
             <label v-if="!isCollapse">相亲交友</label>
            
            </div>
            <div>
              <el-dropdown @command="logOut">
                <span class="el-dropdown-link" style="color:#fff;">
                  admin<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="logout">退出</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
      </el-header>
      <el-container>
        <el-aside class="left-menu" :style="{height:bodyHeight,width:leftAreaWidth+'px'} ">

          <el-menu
            :default-active="$route.path"
            class="el-menu-vertical-demo"
            :collapse-transition="false"
            router
             ref="leftMenuArea"
             style="border:0px;margin-top:15px;"
             >
            <!-- <el-submenu index="1" style="width:100%;" >
              <template slot="title" >
                <i class="el-icon-s-home"></i>
                <span>首页</span>
              </template>
              <el-menu-item-group>
                <template slot="title">分组一</template>
                <el-menu-item index="1-1">选项1</el-menu-item>
                <el-menu-item index="1-2">选项2</el-menu-item>
              </el-menu-item-group>
              <el-menu-item-group title="分组2">
                <el-menu-item index="1-3">选项3</el-menu-item>
              </el-menu-item-group>
              <el-submenu index="1-4">
                <template slot="title">选项4</template>
                <el-menu-item index="1-4-1">选项1</el-menu-item>
              </el-submenu>
            </el-submenu> -->
            <el-menu-item index="/layout/account" style="width:100%;">
              <i class="el-icon-setting"></i>
              <span slot="title" >账号管理</span>
            </el-menu-item>
            <el-menu-item index="/layout/city" style="width:100%;">
              <i class="el-icon-location-information"></i>
              <span slot="title" >城市信息</span>
            </el-menu-item>
            <el-menu-item index="/layout/sys_notice" style="width:100%;">
              <i class="el-icon-tickets"></i>
              <span slot="title" >系统公告</span>
            </el-menu-item>
            <el-menu-item index="/layout/user" style="width:100%;">
              <i class="el-icon-user"></i>
              <span slot="title">用户信息</span>
            </el-menu-item>
            </el-menu>

        </el-aside>
        <el-container>
          <el-main>

            <div style="border:red solid 0px; padding:15px 15px 15px 15px;" >
            <!-- :style="{height:connectHeight+'px'}" <div style="margin:0px 15px;line-height:60px; height:60px; color:#a1acb8; font-weight:700;">
                
                <label>系统配置</label>
                <label style="margin:0px 6px;">/</label>
                <label style="color:#566a7f;">菜单管理</label>
              </div> -->
              <div style="margin:0px 0px; color:#a1acb8;">
                <!--<label v-for="(item,index) in titleMenuArray" >
                  <label :class="item.class">{{item.name}}</label>
                  <label v-if="item.lineShow"  style="margin:0px 6px;">/</label>
                </label>-->
                <el-main class="container">
                  <router-view></router-view>
                </el-main>
              
              </div>
            
            
            </div>

          </el-main>
          
        </el-container>
      </el-container>
    </el-container>  

      
  
  </template>

  <style>
    
 .left-menu{background-color:#f5f7fa;; box-shadow: 0 0.125rem 0.375rem 0 rgba(161,172,184,.12);padding:0px 10px;  }
 .el-menu {
    border-right: solid 1px #e6e6e6;
    list-style: none;
    position: relative;
    margin: 0;
    padding-left: 0;
    background-color: #f5f7fa;
  }
.img-fluid {
   max-width: 95%;
   height: auto;
}

.el-menu-item.is-active {
    color:#696cff;
    background-color: rgba(105,108,255,.16) !important;
    border-radius: 8px;
}

.right-login{
  /**background-color:#e99090;*/

}
.login-area{
  width:100%;
  max-width:500px;
  margin:0px auto;
  
  }

.title-active{color:#566a7f;}


.container {
    width: 100%;
    background: white;
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    overflow: hidden;
   
}

.container .search-area {
    margin:10px 20px 0px 20px;
}

</style>
<script>
  var _this;
export default {
  name: 'Layout',
  data () {
    return {
      bodyHeight: 0,
      rightAreaWidth:0,
      leftAreaWidth:260,
      isCollapse: false,
      connectHeight:0,
      iframHeihgt:0,
      menuurl:'',
      msg: 'Welcome to Your Vue.js App',
      titleMenuArray:[]
    }
  }, mounted(){
     
      window.addEventListener('resize',function(){

        let clientHeight = document.documentElement.clientHeight;
        let leftBodyHeight = clientHeight-60; 
        _this.bodyHeight = leftBodyHeight+"px";
        _this.connectHeight = clientHeight-75;
        _this.iframHeihgt = clientHeight - 135;
        _this.loadPageWidth();
        //alert("test");
      },300)
        let clientHeight = document.documentElement.clientHeight;
         let leftBodyHeight = clientHeight-60; 
        _this.bodyHeight = leftBodyHeight+"px";
        _this.connectHeight = clientHeight-75;
        _this.iframHeihgt = clientHeight - 135;
        _this.loadPageWidth();
        //_this.menuurl = `${process.env.PAGE_URL_PREFIX}`+"#/menu_main";

        _this.menuAction('系统配置');

        //alert("test:"+bodyHeight);

  },created: function () {
      _this = this;
        
      
       //_this.$comutil.getTest();
        //_this.loadPageWidth();
        //const router = Router();

        //let loadPage = _this.$router.push('/menu_main');
        
       //alert(`${process.env.PAGE_URL_PREFIX}`);
         _this.$router.push('/layout/user');

  },methods:{

    async logOut(){

            const response = await _this.$http.syncPost('/login/log_out', {});
            
            console.info('请求结果1:', response )
            if(response.status == 'success'){
                
                this.$router.push('/Login');

            }

    },
    handleMenuClick(path) {
      _this.$router.push({path:path});
    },
    actionUrl:function(url){

      //if(param != 'init'){

      
        //_this.menuurl = `${process.env.PAGE_URL_PREFIX}`+"#/"+url;

      //}
     

    },menuAction:function(menuName){

      let titleMenuArray = [];

      let title = {};
      title.name=menuName;
      title.lineShow=false;
      title.class='title-active';
      titleMenuArray.push(title);


      _this.titleMenuArray = titleMenuArray;

       //_this.menuurl = `${process.env.PAGE_URL_PREFIX}`+"#/menu_main";

    },
    menuClose:function(){
      _this.isCollapse = true;
      const width = this.$refs.leftMenuArea.$el.offsetWidth;
      //var width = _this.$refs.leftMenuArea.getBoundingClientRect().width;

      _this.leftAreaWidth = 75;
      //alert(width);
      _this.loadPageWidth();
    },  
    menuOpen:function(){
      _this.isCollapse = false;
      _this.leftAreaWidth = 260;

      _this.loadPageWidth();
    },
    handleOpen(key, keyPath) {
        console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
        console.log(key, keyPath);
    },loadPageWidth:function(){

      let isCollapse = _this.isCollapse;

      let clientWidth = document.documentElement.clientWidth;
      let rightAreaWidth = 0;
      if(isCollapse){ //开始进行折叠

        rightAreaWidth = clientWidth-75;

      }else{

        rightAreaWidth = clientWidth-260;
      }
      _this.rightAreaWidth = rightAreaWidth;
       

    }

  }
}
</script>>



// WEBPACK FOOTER //
// src/components/Layout.vue